import * as React from 'react';

import * as styles from './LazyImage.css';
import placeholderSrc from './assets/placeholder.png';

interface ILazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Ref div-элемента, внутри которого рендерится картинка. Нужно Observer'у для корректного расчета видимости картинки во вьюпорте
   * Обязательно должен быть div если следовать документации IntersectionObserver
   */
  containerRef: React.RefObject<HTMLDivElement | null>;
}

export const LazyImage: React.FC<ILazyImageProps> = ({ containerRef, src, alt, ...props }) => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const imgRef = React.useRef<HTMLImageElement | null>(null);

  React.useEffect(() => {
    const imgElement = imgRef.current;
    if (!imgElement) {
      return;
    }

    const modalElement = containerRef.current;
    if (!modalElement) {
      return;
    }

    const observerOptions: IntersectionObserverInit = {
      root: modalElement,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observerCallback: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsLoaded(true);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(imgElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  return <img className={styles.image} ref={imgRef} alt={alt} src={isLoaded ? src : placeholderSrc} {...props} />;
};
